import { render, staticRenderFns } from "./AmbienteInfo.vue?vue&type=template&id=c4d1cd82&"
import script from "./AmbienteInfo.vue?vue&type=script&lang=js&"
export * from "./AmbienteInfo.vue?vue&type=script&lang=js&"
import style0 from "./AmbienteInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VSnackbar})
